import { AppSourceEnum } from 'pu-core-library';
import { OrderByEnum } from '@shared/models/common/orderby.enum';
import { MesRemboursemntsRechercheForm } from '@features/mes-remboursements/features/mes-remboursements-recherche/models/remboursement-recherche-form';
import { CategoryFolderEnum } from '@shared/enums/categorie.enum';
import { RemboursementRechercheRequest } from '@features/mes-remboursements/features/mes-remboursements-recherche/models/remboursement-recherche-request';
import { RechercheColonneEnum } from '@shared/enums/recherche-colonne.enum';
import { RemboursementRechercheExportRequest } from '../features/mes-remboursements-recherche/models/remboursement-recherche-export-request';
import { Dispositif } from '@features/referentiel/models/dispositif';

type CommonOpts = { statutAsArray?: boolean };

function buildCommonCriteria(
  form: MesRemboursemntsRechercheForm,
  opts: CommonOpts = {}
) {
  const out: any = {};

  if (form?.numeroDossier) out.numeroDossier = form.numeroDossier;
  if (form?.numeroFacture) out.numeroFacture = form.numeroFacture;

  if (form?.statutDossier) {
    out[opts.statutAsArray ? 'statutsDossier' : 'statutDossier'] =
      opts.statutAsArray ? [form.statutDossier] : form.statutDossier;
  }

  if (form?.decision) out.dateDecisionOperateur = form.decision;

  if (form?.dateDecision) out.dateDecision = form.dateDecision.toLocaleDateString();

  if (form?.dateDebutDemande) out.dateDebutDemande = form.dateDebutDemande.toLocaleDateString();

  if (form?.dateFinDemande) out.dateFinDemande = form.dateFinDemande.toLocaleDateString();

  return out;
}

export class MesRemboursementsFunctions {
  static searchFormToDossierSearchCriteria(
    sirets: string[],
    form: MesRemboursemntsRechercheForm,
    categorie: CategoryFolderEnum,
  ): RemboursementRechercheRequest {

    const common = buildCommonCriteria(form, { statutAsArray: true });

    const dossierCriteria: RemboursementRechercheRequest = {
      sirets: sirets,
      type: AppSourceEnum.POF,
      categorieDossier: categorie,
      page: form.page,
      orderBy: form.orderBy ?? OrderByEnum.DESC,
      orderByColumn: form.orderByColumn ?? RechercheColonneEnum.DATE_DEMANDE,
      ...common,
    };

    if (form.typeDispositif !== "")
      dossierCriteria.dispositif = form.typeDispositif;
    return dossierCriteria;

  }

  static searchFormToRemboursementRechercheExportRequest(
    sirets: string[],
    form: MesRemboursemntsRechercheForm,
    categorie: CategoryFolderEnum,
    dispositifs: Dispositif[]
  ): RemboursementRechercheExportRequest {

    const common = buildCommonCriteria(form, { statutAsArray: false });

    const dossierCriteria: RemboursementRechercheExportRequest = {
      sirets: sirets,
      categorieDossier: categorie,
      ...common
    };

    if (form?.typeDispositif) {
      const selectedDispositif = dispositifs.find(d => d.id === form.typeDispositif);
      dossierCriteria.codeDispositif = selectedDispositif?.code;
    }

    return dossierCriteria;
  }

  static mapToRechercheColonneEnum(field: string | undefined) {
    return Object.values(RechercheColonneEnum).includes(field as RechercheColonneEnum) 
        ? field as RechercheColonneEnum 
        : RechercheColonneEnum.DATE_DEMANDE;
  }
}
